import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Button,
  Spin,
  Col,
  Modal,
  Row,
  Input,
  Typography,
} from 'antd';
import FormSubmitControls from 'components/FormSubmitControls';
import { patchVehiculo } from 'api/recaudacion/vehiculos';
import { onError } from 'utils/handlers';
import { getUsosDeMotocicletas } from 'api/catalogos';
import { getServiciosDelVehiculo } from 'api/recaudacion';
import Select from './Select';

const WidgetServicioPublico = ({
  visible,
  setVisible,
  message,
  vehiculoId,
  callback,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [servicio, setServicio] = useState([]);
  const [uso, setUso] = useState([]);
  useEffect(() => {
    let mounted = true;
    if (vehiculoId) {
      const fetch = async () => {
        const _uso = await getUsosDeMotocicletas();
        const _servicios = await getServiciosDelVehiculo();
        if (mounted) {
          setUso(_uso);
          setServicio(_servicios);
        }
      };
      fetch();
    }
    return () => { mounted = false; };
  }, [visible]);

  const onCancel = () => {
    form.resetFields();
    setVisible(false);
  };
  const onFinish = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = form.getFieldsValue();
      const saved = await patchVehiculo(vehiculoId, values);
      if (saved) {
        callback(saved);
        onCancel();
      }
      setLoading(false);
    } catch (error) {
      onError(error);
    }
  };
  return (
    <Modal
      visible={visible}
      closable={false}
      footer={null}
      title={(
        <FormSubmitControls
          label="Agregar Campos"
          onFinish={onFinish}
          onCancel={onCancel}
          loading={loading}
        />
      )}
      keyboard={!loading}
      maskClosable={!loading}
      onCancel={onCancel}
      forceRender
    >
      <Spin tip="Cargando..." spinning={loading}>
        <Col span={24}>
          <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
          >
            <Row gutter={10}>
              <Col span={24}>
                <Form.Item
                  name="numero_economico"
                  label="Número de Económico"
                  rules={[{ required: true }]}
                >
                  <Input
                    disabled={loading}
                    maxLength={50}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="numero_economico_anterior"
                  label="Número de Económico Anterior"
                  rules={[{ required: true }]}
                >
                  <Input
                    disabled={loading}
                    maxLength={50}
                    allowClear
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item
                  name="servicio"
                  label="Servicio"
                  rules={[{ required: true }]}
                >
                  <Select
                    dataSource={servicio}
                    allowClear
                    labelProp="nombre"
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="uso_del_vehiculo"
                  label="Uso del Vehículo"
                  rules={[{ required: true }]}
                >
                  <Select
                    dataSource={uso}
                    keyLabelRender
                  />
                </Form.Item>
              </Col>
              <Col>
                <Typography.Text>
                  {message}
                </Typography.Text>
              </Col>
            </Row>
            <Form.Item hidden>
              <Button htmlType="submit" />
            </Form.Item>
          </Form>
        </Col>
      </Spin>
    </Modal>
  );
};

WidgetServicioPublico.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  vehiculoId: PropTypes.number,
  callback: PropTypes.func.isRequired,
  message: PropTypes.string,

};

WidgetServicioPublico.defaultProps = {
  vehiculoId: null,
  message: null,

};

export default WidgetServicioPublico;
